var React = require('react');

function Github (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M23.99848,4A20.0019,20.0019,0,0,0,17.678,42.97787c1,.18343,1.365-.434,1.365-.96405,0-.47478-.01731-1.73252-.027-3.40157-5.56332,1.20863-6.73719-2.681-6.73719-2.681a5.2962,5.2962,0,0,0-2.22057-2.92556c-1.81589-1.24092.13739-1.21575.13739-1.21575A4.20112,4.20112,0,0,1,13.25908,33.851c1.78409,3.05631,4.68091,2.17379,5.82054,1.6618a4.27333,4.27333,0,0,1,1.26977-2.67374c-4.44113-.50474-9.11-2.22056-9.11-9.88462A7.73074,7.73074,0,0,1,13.298,17.58773a7.19352,7.19352,0,0,1,.19608-5.293s1.67924-.53777,5.49984,2.05027a18.957,18.957,0,0,1,10.014,0c3.81828-2.588,5.49444-2.05027,5.49444-2.05027a7.1835,7.1835,0,0,1,.199,5.293,7.71761,7.71761,0,0,1,2.0558,5.36675c0,7.68321-4.67613,9.37386-9.13162,9.869a4.77333,4.77333,0,0,1,1.3578,3.70372c0,2.67374-.02456,4.83083-.02456,5.48658,0,.53482.36023,1.15706,1.37524.96172A20.003,20.003,0,0,0,23.99848,4Z","transform":"translate(-3.99977 -4)","style":{"fillRule":"evenodd"}}));
}

Github.displayName = "Github";

Github.defaultProps = {"viewBox":"0 0 40 39.01226"};

module.exports = Github;

Github.default = Github;



// WEBPACK FOOTER //
// ./node_modules/pui-css-iconography/svgs/github.svg